import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_IActivityOverwrite } from '../Type/Type.hive'

export function IDB_activityOverwriteRead(id: number) {
    return IDB_rowRead<Type_IActivityOverwrite>(IDB_globalDb, 'activity_overwrite', id)
}

export function IDB_activityOverwritesDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'activity_overwrite', ids)
}

export function IDB_activityOverwritesReadAll() {
    return IDB_rowsReadAll<Type_IActivityOverwrite>(IDB_globalDb, 'activity_overwrite')
}

export function IDB_activityOverwritesWrite(activityOverwrites: Type_IActivityOverwrite[]) {
    return IDB_rowsWrite(IDB_globalDb, 'activity_overwrite', activityOverwrites)
}

export function IDB_activityOverwriteWrite(activityOverwrite: Type_IActivityOverwrite) {
    return IDB_rowWrite(IDB_globalDb, 'activity_overwrite', activityOverwrite)
}
